var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Renderer2 } from '@angular/core';
import { MessageType } from '../shared/model/message-type';
import { SocketService } from '../shared/services/socket.service';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute } from '@angular/router';
import { GameStatus } from '../shared/model/game-status';
import { GameHostComponent } from '../game-host/game-host.component';
import { SpinnerService } from '../shared/services/spinner.service';
import { WindowsService } from '../shared/services/windows.service';
var PageTriviaHostComponent = /** @class */ (function (_super) {
    __extends(PageTriviaHostComponent, _super);
    function PageTriviaHostComponent(socketService, cookieService, router, resolver, renderer, spinnerService, windowService) {
        var _this = _super.call(this, socketService, cookieService, router, resolver, renderer, spinnerService, windowService) || this;
        _this.user = {};
        _this.connectedUsers = [];
        _this.gamePrefix = 'T';
        _this.gameId = '';
        _this.gameOverMessage = '';
        // Dynamic Styling
        _this.avatarWidth = '100%';
        return _this;
    }
    PageTriviaHostComponent.prototype.hostMessageHandler = function (message) {
        if (message.action === MessageType.Host) {
            this.connectedUsers = Object.values(message.content.users);
            this.avatarWidth = "calc(" + Math.floor(100 / this.connectedUsers.length) + "% - 20px)";
            if (message.content.status === GameStatus.Waiting) {
                this.gameId = message.content.id;
                this.cookieService.set('gameId', this.gameId, 1, '/');
            }
            else if (message.content.status === GameStatus.Complete) {
                this.winner = message.content.winner.name;
                this.gameOverMessage = this.winner + " has won the race!";
            }
        }
    };
    PageTriviaHostComponent.prototype.responseHandler = function (message) {
        if (message.action === MessageType.Question) {
            this.connectedUsers = Object.values(message.content.users);
            this.avatarWidth = "calc(" + Math.floor(100 / this.connectedUsers.length) + "% - 20px)";
            this.currentQuestion = message.content.currentQuestion;
        }
    };
    PageTriviaHostComponent.prototype.getScoreHeight = function (currentScore) {
        var rawScore = currentScore > 100 ? 100 : currentScore;
        return Math.floor(rawScore * 0.45) + 'vh';
    };
    return PageTriviaHostComponent;
}(GameHostComponent));
export { PageTriviaHostComponent };
